import { AiOutlineDelete } from 'react-icons/ai';
import { TbRestore } from 'react-icons/tb';
import { IconButton } from '../../../../../../components/icon-button/icon-button';
import { InfiniteScroll } from '../../../../../../components/infinite-scroll/infinite-scroll';
import { HasAccess } from '../../../../../../features/has-access/has-access';
import { useLang } from '../../../../../../hooks/use-lang';
import { useQueryParams } from '../../../../../../hooks/use-query-params';
import { useLeadStore } from '../../../../../../store/use-lead-store';
import { getContentFields } from '../../helpers';
import s from './leads-cards.module.css';

export const LeadsCards = () => {
  const { t, getLocale } = useLang();
  const { list, isLoadingFetch } = useLeadStore();
  const { addQueryParams } = useQueryParams();

  if (!list?.length && !isLoadingFetch) {
    return <div>{t('Список лидов пуст')}</div>;
  }

  return (
    <ul className={s.feature}>
      {list?.map((item) => {
        const { name, phone, email, sex, age } = getContentFields(item);

        return (
          <li key={item.id} className={s.item}>
            <div className={s.top}>
              <span>
                <div className={s.title}>{t('Источник')}</div>
                <div className={s.subtitle}>{getLocale(item.source)}</div>
              </span>

              <HasAccess service="lead" permissions={['write']}>
                {item.is_deleted ? (
                  <IconButton
                    tooltip={t('Восстановить')}
                    variant="secondary"
                    className={s.actionsButton}
                    size="sm"
                    onClick={() =>
                      addQueryParams({
                        restoreId: String(item.id),
                        restoreName: name,
                      })
                    }
                  >
                    <TbRestore />
                  </IconButton>
                ) : (
                  <IconButton
                    tooltip={t('Удалить')}
                    size="sm"
                    variant="secondary"
                    className={s.actionsButton}
                    onClick={() =>
                      addQueryParams({
                        deleteId: item.id.toString(),
                        deleteName: name,
                      })
                    }
                  >
                    <AiOutlineDelete />
                  </IconButton>
                )}
              </HasAccess>
            </div>

            <div className={s.main}>
              <span>
                <span className={s.title} style={{ marginRight: 17 }}>
                  {t('Телефон')}
                </span>

                <span className={s.subtitle}>{phone}</span>
              </span>

              <div className={s.name}>{name}</div>
            </div>

            <ul className={s.list}>
              <li>
                <div className={s.title}>E-mail</div>
                <div className={s.subtitle}>{email}</div>
              </li>

              <li>
                <div className={s.title}>{t('Пол')}</div>
                <div className={s.subtitle}>{t(sex)}</div>
              </li>

              <li>
                <div className={s.title}>{t('Возраст')}</div>
                <div className={s.subtitle}>{age}</div>
              </li>

              <li>
                <div className={s.title}>{t('Рейтинг')}</div>
                <div className={s.subtitle}>{item.rating?.feedbacks || 0}</div>
              </li>
            </ul>
          </li>
        );
      })}

      <InfiniteScroll onEnterView={() => {}} />
    </ul>
  );
};
